(function ($) {
    'use strict';

    $(function () {

        $('section.simple_square_links .simple-square-links-swiper').each(function () {
            var el = this;
            var section = el.closest('section.simple_square_links');
            var prevEl = section ? section.querySelector('.simple-square-links-slider-arrow-prev') : null;
            var nextEl = section ? section.querySelector('.simple-square-links-slider-arrow-next') : null;

            if (el.dataset.swiperInitialized === '1') {
                return;
            }

            el.dataset.swiperInitialized = '1';

            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                speed: 600,
                watchOverflow: true,
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },
            });
        });
    });
})(jQuery);
